import React from 'react'
import {  Icon } from '@roo/roo'

const PswIcon = () => (
  <Icon name="lock" style={{ fontSize: '20px', color: '#cccccc' }}/>
)

export default PswIcon